import { jsPDF } from 'jspdf';
import { addPdfFooter } from './footer';

export function createLeadsPdf(rows: any[], daily = false) {
  const pdf = new jsPDF({ unit: 'mm', format: 'a4' });
  const widths = [65, 47, 66];
  const positions = [16, 81, 128];
  let y = 70;
  const heading = () => {
    pdf.setFillColor(16, 42, 67); pdf.rect(0, 0, 210, 37, 'F');
    pdf.setTextColor(255, 255, 255); pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(19); pdf.text('RELATÓRIO DE LEADS', 16, 17);
    pdf.setFontSize(10); pdf.text('Dons em Ação | Francisney Liberato', 16, 27);
    pdf.setTextColor(31, 41, 51); pdf.setFontSize(10);
    pdf.text(`${daily ? 'Leads do dia' : 'Leads acumulados'} - Total: ${rows.length}`, 16, 48);
    pdf.setFont('helvetica', 'normal'); pdf.setFontSize(8);
    pdf.text(`Emitido em ${new Date().toLocaleString('pt-BR', { timeZone: 'America/Cuiaba' })}`, 16, 55);
    pdf.setFillColor(23, 107, 92); pdf.rect(16, 61, 178, 9, 'F');
    pdf.setTextColor(255, 255, 255); pdf.setFont('helvetica', 'bold');
    ['Nome completo', 'WhatsApp', 'E-mail'].forEach((label, i) => pdf.text(label, positions[i] + 2, 67));
    y = 70;
  };
  heading();
  rows.forEach((row, index) => {
    pdf.setFont('helvetica', 'normal'); pdf.setFontSize(9);
    const values = [row.participant_name || '', String(row.whatsapp || ''), row.email || ''];
    const lines = values.map((value, i) => pdf.splitTextToSize(value, widths[i] - 4) as string[]);
    const height = Math.max(12, ...lines.map(value => value.length * 4.5 + 5));
    if (y + height > 253) { pdf.addPage(); heading(); }
    pdf.setFillColor(...(index % 2 ? [234, 243, 238] : [248, 250, 249]) as [number, number, number]);
    pdf.rect(16, y, 178, height, 'F'); pdf.setTextColor(31, 41, 51);
    lines.forEach((value, i) => pdf.text(value, positions[i] + 2, y + 5));
    const phone = values[1].replace(/\D/g, '');
    if (phone) pdf.link(83, y, 43, height, { url: `https://wa.me/${phone.length <= 11 ? '55' : ''}${phone}` });
    if (values[2]) pdf.link(130, y, 62, height, { url: `mailto:${values[2]}` });
    y += height;
  });
  if (!rows.length) { pdf.setTextColor(82, 99, 109); pdf.text('Nenhum lead encontrado para este período.', 18, 81); }
  addPdfFooter(pdf);
  for (let page = 1; page <= pdf.getNumberOfPages(); page++) {
    pdf.setPage(page); pdf.setFontSize(8); pdf.setTextColor(82, 99, 109);
    pdf.text(`Página ${page} de ${pdf.getNumberOfPages()}`, 194, 259, { align: 'right' });
  }
  return pdf;
}
